import React from "react";
import { useDispatch } from "react-redux";
import { FormBuilder } from "../form/FormBuilder";
import { Currency } from "../../interfaces/screens/billing";
import {
  addCurrency,
  updateCurrency,
} from "../../screens/content/settings/Currencies/reducer";
import { AppDispatch, store } from "../../redux/store";
import { hideModal } from "../../connected-components/modal/reducer";
import { FormComponent } from "../../shared/utils/enums";

interface CurrencyEditorProps {
  currency?: Currency;
  isEdit: boolean;
}

const CurrencyEditor: React.FC<CurrencyEditorProps> = ({
  currency,
  isEdit,
}) => {
  const dispatch: AppDispatch = useDispatch();

  const handleFormSubmit = (data: any) => {
    if (isEdit && currency) {
      dispatch(updateCurrency({ ...currency, ...data }));
    } else {
      dispatch(addCurrency(data as Currency));
    }
    store.dispatch(hideModal());
  };

  const schema = {
    type: "object",
    properties: {
      code: {
        type: "string",
        label: "Currency Code",
        component: FormComponent.Input,
        componentProps: {
          type: "text",
          disabled: isEdit,
        },
        required: true,
      },
      name: {
        type: "string",
        label: "Currency Name",
        component: FormComponent.Input,
        componentProps: {
          type: "text",
        },
        required: true,
      },
      exchange_rate: {
        type: "number",
        label: "Exchange Rate (to USD)",
        component: FormComponent.Input,
        required: true,
        componentProps: {
          type: "number",
        },
      },
      is_default: {
        type: "boolean",
        label: "Set as Default Currency",
        component: FormComponent.Checkbox,
        required: false,
        componentProps: {},
      },
    },
  };

  return (
    <div className="p-4">
      <FormBuilder
        schema={schema}
        onSubmit={handleFormSubmit}
        initialValues={currency}
      />
    </div>
  );
};

export default CurrencyEditor;
